// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { io } from 'socket.io-client';
import { log, errorlog } from '../logger/logger';
import { PopupUI } from '../invite/invite';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let store = {};
let node = {};
let settings = {};
let edge = {};
let i18n = {};
let i18nJson = {};

let users = []; // all users joined to map
let usersColorsAssigned = [];
let userCurrent = null; //
let socket = null;
let activeEdits = null; // elements blocked from loading
let blockList = []; // all blocked elements
let sectionCurrent = null; // locally edited
let edgeCurrent = null; // locally edited
let mapCurrent = null; // locally edited
let formUsers = [];

const TYPES = {
    MAP: 'map',
    EDGE: 'edge',
    NODE: 'node'
}

let isMouseDown = false;
let isDragging = false;

let currentVisibilityLevel = 1;
let currentVisibilityLevelScales = {};

const mapLevelControlWrapper = $('map-level-control');
const mapLevelControlNodesWrapper = $('map-level-control-nodes');
const mapLevelControlEdgesWrapper = $('map-level-control-edges');
let mapLevelControlIsActive = false;

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Map {

    constructor() {}

    init(globalStore, globalNode, globalSettings, globalEdge, globalI18n) {
        log('map init');

        // global objects
        store = globalStore;
        node = globalNode;
        settings = globalSettings;
        edge = globalEdge;
        i18n = globalI18n;
        i18nJson = i18n.getCurrentJson();

        // needed map stuff
        addDefaultMapDataToStore();
        updateMapVisibilityLevelScales();
        updateMapWidthHeight();
        updateCenterMap();
        updateBackgroundColor();
        setEventListener();
        connectToBackend();
    }

    removeSelectedNodeOrEdge() {
        removeSelectedNodeOrEdge();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------

// EVENTLISTENER
// ---------------------------------------------------------------
function setEventListener() {
    let mouseX, mouseY;
    const app = $('app');
    const map = $('map');
    let dragStartX, dragStartY;

    app.on('mousedown touchstart', 'map', (event) => {
        event.stopPropagation();

        const mapOffset = map.offset();
        mouseX = event.pageX - mapOffset.left;
        mouseY = event.pageY - mapOffset.top;

        dragStartX = mouseX;
        dragStartY = mouseY;
        isMouseDown = true;

        settings.hide();
        edge.removeClassSelected();
        node.removeClassSelected();
        node.removeClassDrawSelected();
        node.clearDrawingStates();
        
        // check if node/edge/map opened to emit event accordingly
        sectionEditedCheck();
        edgeEditedCheck();
        mapEditedCheck();
    });

    app.on('mouseup touchend', 'map', (event) => {
        event.stopPropagation();

        map.removeClass('dragging');
        isMouseDown = false;
        isDragging = false;
    });

    app.on('dblclick', 'map', (event) => {
        event.stopPropagation();

        const isCurrentLevelLocked =
            $(`map-controls [data-visibility-level="${currentVisibilityLevel}"] .visibility-level-locking`)
                .is('.locked');

        if(!isCurrentLevelLocked) {
            const mapOffset = map.offset();
            mouseX = event.pageX - mapOffset.left;
            mouseY = event.pageY - mapOffset.top;

            addNode(mouseX, mouseY, currentVisibilityLevelScales[currentVisibilityLevel]);
            nodeCreatedSync(mouseX, mouseY, currentVisibilityLevelScales[currentVisibilityLevel])
        }
    });

    app.on('mousemove touchmove', 'map', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if(isMouseDown === true && isDragging === false) {
            map.addClass('dragging');
        }

        if(isMouseDown === true) {
            isDragging = true;

            const mapOffset = map.offset();
            mouseX = event.pageX - mapOffset.left;
            mouseY = event.pageY - mapOffset.top;

            updateMapPosition(dragStartX, dragStartY, mouseX, mouseY);
        }
    });
    
    map.on('mousemove', userPointerSend);

    $(document).on('keyup', (event) => {
        if ($(event.target).is(':input')) {
            return;
        }
        switch (event.keyCode) {
            // remove selected element (delete)
            case 46:
                event.preventDefault();
                $(document).trigger('elementRemoveRemote')
                removeSelectedNodeOrEdge();
                break;
            // copy selected element (c)
            case 67:
                event.preventDefault();
                const currentNode = $('node.selected'),
                  currentNodeId = currentNode.data('id');
                if (currentNode) {
                    $(document).trigger('nodeCopiedEmit', currentNodeId);
                }
                copySelectedNode();
                break;
            // change visibility level (+)
            case 107:  // numblock
            case 171:
                event.preventDefault();
                updateMapVisibilityLevelKeypress('+');
                break;
            // change visibility level (-)
            case 109:  // numblock
            case 173:
                event.preventDefault();
                updateMapVisibilityLevelKeypress('-');
                break;
        }
    });

    // triggered from modules/settings/settings.js
    $(document).on('updateMapDataEvent', () => {
        updateMapDataToDom();

        // level control > node/edge show/hide
        updateMapLevelControl('init', -1);
    });

    // triggered from modules/xhr/xhr.js
    $(document).on('initMapDataEvent', () => {
        drawInitMap();
    });
    
    // triggered from modules/node/node.js
    // fired after popup's structure created;
    $(document).on('nodeClickedEvent', (event, currentNode) => {
        event.stopPropagation();
        const currentNodeId = currentNode.data('id');
        // check is there active edited section locally
        sectionEditedCheck();
        // or edges/map
        edgeEditedCheck();
        mapEditedCheck();
        // block section accordingly when popup is opening
        // check blocked elements from initials
        for ( let nodeId in activeEdits.nodes ) if (activeEdits.nodes.hasOwnProperty(nodeId) ) {
            const elementEditors = activeEdits.nodes[nodeId];
            if( elementEditors.length && parseInt(currentNodeId) === parseInt(nodeId)) {
                elementEditors.forEach( editedElement => {
                    //&& edit.userId !== userCurrent.id
                    if (editedElement.user !== userCurrent.id){
                        log('blocked element from initials');
                        sectionBlockDOM(editedElement.userId, editedElement.lockExtent);
                        // break;
                    }
                })
            }
        }
        // otherwise get it from local blockList
        // so that there are placed elements which been edited since current user connected
        log(blockList);
        blockList.forEach(element => {
            log(element);
            if(parseInt(currentNodeId) === parseInt(element.elemId)){
                log('blocked element from blocklist:');
                log(element);
                log('----------------------------->');
                sectionBlockDOM(element.userId, element.lockExtent);
                return false;
            }
        });
        
    });
    
    // triggered from modules/edge/edge.js
    $(document).on('edgeClickedEvent', (event, currentEdge) => {
        event.stopPropagation();
        const currentEdgeId = currentEdge.data('id');
        const activeBlockedIndex = blockList.findIndex((el, index) => el.elemId === currentEdgeId);
        log(activeBlockedIndex);
        log('no EDGE EVENT then ');
        if (activeBlockedIndex > -1) return;
        log('EDGE EVENT')
        const LockEvent = {
            userId: userCurrent.id,
            elemType: 'edge',
            elemId: currentEdgeId,
            lockExtent: 'content'
        };
        edgeEditedCheck();
        sectionEditedCheck();
        // if user edited map trigger sync map settings with other users
        mapEditedCheck();
        edgeCurrent = LockEvent;
        
        socket.emit('start editing element', LockEvent);
    });
    
    // triggered from modules/settings/settings.js
    $(document).on('settingsClosed', event => {
        // check if is there edited elements
        edgeEditedCheck();
        sectionEditedCheck();
        // if user edited map trigger sync map settings with other users
        mapEditedCheck();
    });
    
    // triggered from modules/settings/settings.js
    $(document).on('sectionEditedOn', (event, LockEvent) => {
        if (LockEvent.elemType === 'edge' || LockEvent.elemType === 'map') return;
        if (sectionCurrent && (sectionCurrent.lockExtent !== LockEvent.lockExtent)) {
            log('section edited off triggered from sectionEditedOn because of:');
            log(sectionCurrent);
            socket.emit('stop editing element', sectionCurrent);
        }
        LockEvent.userId = userCurrent.id;
        sectionCurrent = LockEvent;
        socket.emit('start editing element', LockEvent);
        
        // test update user state event
        log('------- ---------- ------');
        log('Event["start editing element"] emitted');
        log(sectionCurrent);
        log('------- ---------- ------');
    })
    
    // triggered from modules/settings/settings.js
    $(document).on('sectionEditedOff', (event, LockEvent) => {
        if (LockEvent.elemType === 'edge' || LockEvent.elemType === 'map') return;
        log('section edited off');
        LockEvent.userId = userCurrent.id;
        socket.emit('stop editing element', LockEvent); // sectionCurrent?
        log(sectionCurrent);
        nodeDataSubmitSync(sectionCurrent.elemId);
        log('------- ---------- ------');
        log('Event["stop editing element"] emitted');
        log(LockEvent);
        log('------- ---------- ------');
        sectionCurrent = null;
    })
    
    // send copied node element
    $(document).on('nodeCopiedEmit', (event, currentNodeId) => {
        nodeCopiedSync(currentNodeId);
        
    });
    // send deleted node
    $(document).on('elementRemoveRemote', (event) => {
        const getSelectedElement = $('.selected');
        log('elementRemoveRemote :');
        log(getSelectedElement);
        if(getSelectedElement.length > 0) {
            const getElementTagName = getSelectedElement.prop('tagName').toLowerCase();
            const getElementId = getSelectedElement.data('id');
            // check if element is not edited
            if (getSelectedElement.hasClass('edited')) return;
            elementDeletedSync(getElementTagName, getElementId);
        }
        
    })
    
    // triggered from modules/node/node.js
    $(document).on('nodeDraggingOff', ((event, nodeId) => {
        log('Node dragging off ' + nodeId);
        nodeDataSubmitSync(nodeId)
    }));
    
    // triggered from modules/settings/settings.js
    $(document).on('eventLogRequested', () => {
        log('emitted request event log');
        socket.emit('request event log');
    });
    
    // triggered from modules/settings/settings.js
    $(document).on('mapSettingsOpened', () => {
        const LockEvent = {
            userId: userCurrent.id,
            elemType: 'map',
            lockExtent: 'appearance'
        }
        // todo check if map not in the blockList
        // check if map not edited by anyone
        /*const activeBlockedIndex = blockList.findIndex((el, index) => el.elemType === TYPES.MAP);
        if (activeBlockedIndex > -1) return;*/
        
        if (!mapCurrent && !activeEdits.map.length){
            mapCurrent = LockEvent;
            socket.emit('start editing element', LockEvent);
        } /*else if (!mapCurrent && activeEdits.map.length && activeEdits.map[0].userId !== userCurrent.id){
            sectionBlockDOM(activeEdits.map[0].userId, 'appearance');
        }*/
    });
    
    // triggered from modules/node/node.js
    $(document).on('edgeCreatedEvent', (event, {fromNodeId, toNodeId}) => {
        // submit map edit event
        edgeCreatedSend({fromNodeId, toNodeId})
    })

    // triggered from modules/settings/settings.js
    $(document).on('templateNodeCreate', (event, designData) => {
        const diff = {};
        diff.nodeTemplateCreate = {
            [userCurrent.id] : designData
        }
        socket.emit('submit map edit', diff)
    })

    $(document).on('templateNodeUpdate', (event, designData) => {
       const diff = {};
       diff.nodeTemplateUpdate = {
           [userCurrent.id] : designData
       }
        socket.emit('submit map edit', diff)
    });

    $(document).on('templateEdgeCreate', (event, designData) => {
        const diff = {};
        diff.edgeTemplateCreate = {
            [userCurrent.id] : designData
        }
        socket.emit('submit map edit', diff)
    })

    $(document).on('templateEdgeUpdate', (event, designData) => {
        const diff = {};
        diff.edgeTemplateUpdate = {
            [userCurrent.id] : designData
        }
        socket.emit('submit map edit', diff)
    });

    app.on('click', 'map-controls > ul .level-control-button', (event) => {
        const currentElement = $(event.currentTarget);
        toggleMapLevelControl(currentElement);
    });

    app.on('click', 'map-controls > ul .visibility-level, map-controls > ul .visibility-level-center', (event) => {
        const currentElement = $(event.currentTarget);
        toggleMapVisibilityControls(currentElement);
    });

    app.on('click', 'map-controls > ul .visibility-level-locking', (event) => {
        const currentElement = $(event.currentTarget);
        toggleVisibilityLevelLockingControls(currentElement);
    });

    // triggered from modules/node/node.js
    // triggered from modules/edge/edge.js
    $(document).on('updateMapLevelControlEvent', (event, type, id) => {
        updateMapLevelControl(type, id);
    });

    app.on('click', '.map-level-control-nodes-toggle', (event) => {
        event.preventDefault();
        const currentElement = $(event.currentTarget);
        toggleMapLevelControlNodes(currentElement);
    });

    app.on('click', '.map-level-control-all-edges', (event) => {
        const currentElement = $(event.currentTarget);
        toggleMapLevelControlVisibilityAllEdges(currentElement);
    });

    app.on('click', '.map-level-control-node', (event) => {
        const currentElement = $(event.currentTarget);
        toggleMapLevelControlVisibilityNode(currentElement);
    });

    app.on('click', '.map-level-control-level-button', (event) => {
        const currentElement = $(event.currentTarget);
        toggleMapLevelControlVisibilityLevel(currentElement);
    });
    
    app.on('click', 'map-user-expand', event => {
       if (mapUsers.length < USERS.LIMIT) {
           return false;
       } else {
           mapUsersShow(mapUsers);
       }
       
    });
    
    app.on('click', 'map-user-toggle', event => {
        const usersList = $('map-user-list');
        if (usersList.hasClass('hidden')){
            usersList.removeClass('hidden');
            expandButtonCheckVisibility();
        } else {
            usersList.addClass('hidden');
            expandButtonCheckVisibility();
        }
    });
    
    app.on('click', 'map-user-invite', event => {
        PopupUI.actions.modalOn();
    })
}

function setCurrentVisibilityLevel(visibilityLevel) {
    currentVisibilityLevel = visibilityLevel;
    $(document).trigger('currentVisibilityLevel', [parseInt(currentVisibilityLevel)]);
}

// SOCKET.IO
// ---------------------------------------------------------------

function connectToBackend() {
    $(document).on('initMapDataEvent', () => {
        socket = io({
            query: {
                client_slug: store.get().map.owner,
                map_id: store.get().map.id
            }
        });

        socket.on('connect', event => {
            log('')
            log('user CONNECT');
            log('')
            socket.emit('join map editors', 'canvas_editor');
        });
        
        socket.on('duplicate user error', error => {
            log('')
            log('______________');
            log('Double user error detected');
            log(error);
            log('______________');
            log('')
            $('blocked-area')
                .html(error.message)
                .addClass('blocked');
            $('app').remove();
        });

        socket.on('user connected', user => {
            log('')
            log('user CONNECTED');
            log('')
            userCurrent = user;
            // init popup invitation ui
            PopupUI.init(socket);
        });

        socket.on('user left map editors', joinLeaveEvent => {
            mapUserRemove(joinLeaveEvent.user);
        });
        
        socket.on('user joined map editors', joinLeaveEvent => {
            log('')
            log('______________');
            log('User joined map editors');
            log(joinLeaveEvent);
            log('______________');
            log('')
            const usersNew = joinLeaveEvent.users.canvas_editor;
            const usersFormNew = joinLeaveEvent.users.popup_form;
            // to compare existing and received users
            // to add to the map a new ones
            if (usersFormNew) {
                usersFormNew.forEach( formUser => {
                    if ( !users.find(user => user.id === formUser.id )){
                        if (formUser.id !== userCurrent.id) {
                            formUsers.push(formUser.id);
                            formUserAdd(formUser);
                        }
                    }
                });
            }
            usersNew.forEach((userNew, indexNew, arrNew) => {
                if ( !users.find(user => user.id === userNew.id )){
                    if (userNew.id !== userCurrent.id) {
                        mapUserAdd(userNew);
                    }
                }
            });
            log('');
            log('------------------');
            log('Users joined map editors:');
            log(joinLeaveEvent);
            log('------------------');
        });
    
        socket.on('update active edits', event => {
            log('');
            log('------------------');
            log('activeEdits at initial is:');
            log(event);
            log('------------------');
            activeEdits = event;
            mapInitialEditsShow();
        });
        
        socket.on('updated user state', UserState => {
            userPointerReceived(UserState);
        });
        
        socket.on('block element', LockEvent => {
            log('');
            log('------------------');
            log('block element');
            log(LockEvent);
            log('------------------');
            
            const currentElement = $('.selected'),
              currentElementId = currentElement.data('id');
            // add blocked el to local blockList
            blockList.push(LockEvent);
            // block DOM for any user different from whom currently edit this element
            if (LockEvent.userId !== userCurrent.id) {
                if (LockEvent.elemType === TYPES.MAP) {
                    mapEditedCheckExternal(LockEvent)
                } else {
                    elementBlockDOM(LockEvent.elemType, LockEvent.elemId);
                    // mark edit type on element
                    elementEditTypeMarkOn(LockEvent);
                    // if popup is opened
                    if (currentElement && currentElementId === LockEvent.elemId) {
                        sectionBlockDOM(LockEvent.userId, LockEvent.lockExtent);
                    }
                }
            }
            
        });
    
        socket.on('unblock element', LockEvent => {
            log(' ');
            log(' ');
            log('------------------');
            log('unblock element' + LockEvent.elemId);
            log(LockEvent);
            log('------------------');
            const elementBlockedIndex = blockList.findIndex((el, index) => {
                return (el.elemType === LockEvent.elemType) &&
                  (parseInt(el.userId) === parseInt(LockEvent.userId)) &&
                  (el.lockExtent === LockEvent.lockExtent) &&
                  (el.elemId === LockEvent.elemId)
            });
            // remove blocked el from local blockList if it's blocked while current user is online
            if (elementBlockedIndex > -1) blockList.splice(elementBlockedIndex, 1);
            // remove blocked from activeEdits if it's blocked before current user join in
            // TODO[improve] - parse activeEdits from beginning to a block list and remove activeEdits from code
            if (LockEvent.elemType !== TYPES.MAP) {
                // check if element exist
                if (!$(`${LockEvent.elemType}[data-id=${LockEvent.elemId}]`)) return;
                const activeEditsCurrent = activeEdits[`${LockEvent.elemType}s`];
                for (let element in activeEditsCurrent) if (activeEditsCurrent.hasOwnProperty(element)) {
                    if (parseInt(LockEvent.elemId) === parseInt(element)){
                        const elementEditors =  activeEditsCurrent[element];
                        elementEditors.forEach( (editedElement, index, arr) => {
                            if (LockEvent.userId === editedElement.userId) {
                                arr.splice(index, 1);
                                // if array is empty ( not edited ) remove property from activeEdits
                                if (!arr.length) delete activeEditsCurrent[element];
                            }
                        })
                    }
                }
    
                // unblock DOM for any user different from whom currently edit this element
                if (LockEvent.userId !== userCurrent.id) {
                    // check if there edited section by another user
                    // by checking activeEdits/blockList
                    const activeEditsElements = activeEdits[`${LockEvent.elemType}s`];
                    const activeBlockedIndex = blockList.findIndex((el, index) => el.elemId === LockEvent.elemId);
                    // since received element from LockEvent was deleted from blockList/activeEdits
                    // trying to find the same id after that tell us if this element is edited by someone else
                    if (!activeEditsElements[LockEvent.elemId] && activeBlockedIndex < 0){
                        // if id didn't found at activeEdits or blockList -> unblock DOM
                        elementUnblockDOM(LockEvent.elemType, LockEvent.elemId);
                    } else if ( activeBlockedIndex > -1 ){
                        // otherwise unblock DOM elements for users who didn't sent this event
                        // unblock DOM only if currentUser equal to who edited this el
                        if (blockList[activeBlockedIndex].userId === userCurrent.id){
                            elementUnblockDOM(LockEvent.elemType, LockEvent.elemId);
                        }
                    }
                    sectionUnblockDOM(LockEvent.userId, LockEvent.lockExtent);
                    // mark edit type on element
                    elementEditTypeMarkOff(LockEvent);
                }
                
            } else {
                const mapBlockedIndex = blockList.findIndex( element => element.elemType === TYPES.MAP);
                if (mapBlockedIndex > -1){
                    blockList.splice(mapBlockedIndex, 1);
                }
                $('map-settings').removeClass();
            }
        });
        
        socket.on('sync map edit', diff => {
            // define edge/node/map differences types saving
            for (const [element, value] of Object.entries(diff)){
                if (element === TYPES.MAP){
                    $(document).trigger('mapSettingsDataSync', [diff.map]);
                } else if (element === TYPES.EDGE){
                    $(document).trigger('edgeDataSync', [diff.edge]);
                } else if (element === TYPES.NODE){
                    $(document).trigger('syncNodePosition', [diff.node]);
                } else if (element === 'copy'){
                    const userId = Object.keys(diff.copy)[0];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        // diff.copy === {userId: nodeId}
                        node.copy([diff.copy[userId]][0], 'regular')
                    }
                } else if (element === 'edgeCreated'){
                    const userId = Object.keys(diff.edgeCreated)[0];
                    const edgeCreated = diff.edgeCreated[userId];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        $(document).trigger('syncEdgeCreated', [edgeCreated]);
                    }
                } else if (element === 'create'){
                    const userId = Object.keys(diff.create)[0];
                    const newNode = diff.create[userId];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        // $(document).trigger('syncCreatedNode', [diff.create])
                        addNode(newNode.mouseX, newNode.mouseY, newNode.currentMapScale);
                    }
                } else if (element === 'delete'){
                    // diff.delete === {userId: {elemType, elemId}}
                    const userId = Object.keys(diff.delete)[0];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        elementDeleteEmitted(diff);
                        // node.remove(getSelectedElement, getElementId);
                        // edge.remove(getSelectedElement, getElementId);
                    }
                } else if (element === 'popup'){
                    // coming from popup form
                    log(diff.popup);
                    $(document).trigger('syncPopupData', [diff.popup])
                    
                } else if (element === 'nodeTemplateCreate'){
                    log('---- -- nodeTemplateCreate');
                    log(diff.nodeTemplateCreate);
                    const userId = Object.keys(diff.nodeTemplateCreate)[0];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        $(document).trigger('templateNodeCreatedSync', [diff.nodeTemplateCreate])
                    }
                } else if (element === 'nodeTemplateUpdate'){
                    log('---- -- nodeTemplateUpdate');
                    log(diff.nodeTemplateUpdate);
                    const userId = Object.keys(diff.nodeTemplateUpdate)[0];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        $(document).trigger('templateNodeUpdatedSync', [diff.nodeTemplateUpdate])
                    }
                } else if (element === 'edgeTemplateCreate'){
                    log('---- -- edgeTemplateCreate');
                    log(diff.edgeTemplateCreate);
                    const userId = Object.keys(diff.edgeTemplateCreate)[0];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        $(document).trigger('templateEdgeCreatedSync', [diff.edgeTemplateCreate])
                    }
                } else if (element === 'edgeTemplateUpdate'){
                    log('---- -- edgeTemplateUpdate');
                    log(diff.edgeTemplateUpdate);
                    const userId = Object.keys(diff.edgeTemplateUpdate)[0];
                    if (parseInt(userCurrent.id) !== parseInt(userId)){
                        $(document).trigger('templateEdgeUpdatedSync', [diff.edgeTemplateUpdate])
                    }
                }
            }
        });
        
        socket.on('element free to edit', LockEvent => {
            log('element free to edit _*_ ~V~')
            log(LockEvent);
            log('element free to edit _*_ ~^~')
        });
    
        socket.on('requested invitation', emails => {
            log('requested invitation $$ ~V~')
            log(emails);
            log('requested invitation $$ ~^~')
        });
    
        socket.on('requested event log"', MapLogEvent => {
            log('requested event log" $$ ~V~')
            log(MapLogEvent);
            log('requested event log" $$ ~^~')
        });
    });
}

// ---------------------------------------------------------------
// MAP
// ---------------------------------------------------------------

// INIT STORE MAP
// ---------------------------------------------------------------
function addDefaultMapDataToStore() {
    const data = {
        state: 'draft', // published
        visibilityLevels: 1,
        measurement: {
            width: 1280,
            height: 800
        },
        position: {
            x: 0,
            y: 0
        },
        design: {
            bgColorTop: '#68C4D7',
            bgColorBottom: '#209B90'
        },
        fonts: {
            popUpContent: '',
            articleContent: '',
            linkContent: '',
            nodeContent: '',
            edgeContent: ''
        },
        content: {
            title: '',
            description: ''
        },
        header: {
            state: 'hidden', // visible
            design: {
                bgColor: '#000000',
                fontColor: '#FFFFFF'
            }
        }
    };

    store.get().map.set(data);

    log('--- map.js ---');
    log('init map data to store');
    log(store.get());
    log('---------------');
}

// INIT MAP
// ---------------------------------------------------------------
function drawInitMap() {

    // draw map --> position from last saving
    // const x = store.get().map.position.x;
    // const y = store.get().map.position.y;

    // updateMapFromDom(x, y);
    // updateMapWidthHeight();
    // updateBackgroundColor();

    // translate some map base stuff like "Map-Optionen" or "?"
    // populate map manage options
    $('map-help').html(i18nJson.help.headlineShort);
    // $('map-settings').html(i18nJson.map.settings.headline);
    $('map-settings').html(`<i class="fas fa-sliders-h"></i>`);
    $('map-logs').html(`<i class="fas fa-clipboard-list"></i>`).addClass('disabled');
    $('map-user-toggle').html(`<i class="fas fa-users"></i>`);
    $('map-user-invite').html(`<i class="fas fa-plus"></i>`);
    $('map-user-expand').html(`<i class="fas fa-angle-double-right"></i>`);
    
    // draw map --> center map directly
    updateMapDataToDom();

    // level control > node/edge show/hide
    updateMapLevelControl('init', -1);

}

// UPDATE MAP
// ---------------------------------------------------------------
function updateMapDataToDom() {
    updateMapVisibilityLevelScales();
    updateMapMaxVisibilityLevel();
    updateMapVisibilityControls();
    updateMapWidthHeight();
    updateCenterMap();
    updateBackgroundColor();
}

function updateMapWidthHeight() {
    const map = $('map');

    // optic
    map.css({
        'width': `${store.get().map.measurement.width}px`,
        'height': `${store.get().map.measurement.height}px`
    });

    // data --> style.scss
    map.attr({
        'data-width': store.get().map.measurement.width,
        'data-height': store.get().map.measurement.height
    });
}

function updateCenterMap() {
    // window
    const windowHeight = $(window).height();
    const windowWidth = $(window).width();

    // map
    const mapWidth = store.get().map.measurement.width;
    const mapHeight = store.get().map.measurement.height;

    // center map
    const x = (windowWidth - mapWidth) / 2;
    const y = (windowHeight - mapHeight) / 2;

    updateMapFromStore(x, y);
    updateMapFromDom(x, y);
}

function updateBackgroundColor() {
    $('map').css({
        'background': `linear-gradient(to bottom, ${store.get().map.design.bgColorTop}, ${store.get().map.design.bgColorBottom})`
    });
}

function updateMapPosition(dragStartX, dragStartY, mouseX, mouseY) {
    const position = store.get().map.position;

    const newX = mouseX - dragStartX + position.x;
    const newY = mouseY - dragStartY + position.y;

    updateMapFromDom(newX, newY);
    updateMapFromStore(newX, newY);
}

function updateMapFromDom(newX, newY) {
    const map = $('map');
    map.css({
        'transform' : `translate(${newX}px, ${newY}px) scale(${currentVisibilityLevelScales[currentVisibilityLevel]})`
    });

    // add class only currently dragging is inactive
    if(isDragging === false) {
        map.removeClass().addClass(`current-visibility-level-${currentVisibilityLevel}`);
    }
}

function updateMapFromStore(newX, newY) {
    // update map store
    store.get().map.set({
        position: {
            x: newX,
            y: newY
        }
    });

    log('--- map.js ---');
    log('update map position from store');
    log(store.get().map);
    log('---------------');
}

// VISIBILITY MAP
// ---------------------------------------------------------------
function updateMapMaxVisibilityLevel() {
    const maxVisibilityLevel = store.get().map.visibilityLevels;

    // Change the current visibility level if it is outside range
    if (currentVisibilityLevel > maxVisibilityLevel) {
        setCurrentVisibilityLevel(maxVisibilityLevel);
    }
}

function updateMapVisibilityControls() {
    let markup = '';

    // visibility levels > 1 --> show visibility controls
    if(store.get().map.visibilityLevels !== 1) {
        markup += '<ul>';
            markup += `<li>
                           <a class="level-control-button${(mapLevelControlIsActive === true) ? ' active' : ''}"
                              title="${i18nJson.map.levelControl.buttonHover}"></a>
                       </li>`;
            for(let level=store.get().map.visibilityLevels; level >= 1; level--) {
                markup += `<li data-visibility-level="${level}">
                               <a class="visibility-level-locking"
                                  title="${i18nJson.map.visibilityLevelLockHoverContent.replace('[level]', level)}"></a>
                               <a class="visibility-level${(level === currentVisibilityLevel) ? ' active' : ''}"
                                  title="${i18nJson.map.visibilityLevelHoverContent.replace('[level]', level)}"
                                  >${level}</a>
                           </li>`;
            }
            markup += `<li data-visibility-level="0">
                           <a class="visibility-level-center"
                              title="${i18nJson.map.visibilityLevelCenterHoverContent}"
                              ></a>
                       </li>`;
        markup += '</ul>';
    }

    $('map-controls')
        .html(markup)
        .find('a').on('click', function (event) {
            event.preventDefault();
        });
}

function toggleMapVisibilityControls(currentElement) {
    const visibilityLevel = currentElement.parent().data('visibility-level');
    const mapControls = currentElement.parents('map-controls');
    const mapControlItems = mapControls.find('.visibility-level');
    setCurrentVisibilityLevel(visibilityLevel);

    // change visibility level
    if(currentElement.hasClass('visibility-level') === true) {
        mapControlItems.removeClass('active');
        currentElement.addClass('active');
        updateMapFromDom(store.get().map.position.x, store.get().map.position.y);

    // take care of visibility controls + center map + ...
    } else {
        updateMapDataToDom();
    }
}

function toggleVisibilityLevelLockingControls(currentElement) {
    const visibilityLevel = currentElement.parent().data('visibility-level');

    // change visibility level locking
    if(currentElement.hasClass('visibility-level-locking') === true) {
        currentElement.toggleClass('locked');
    }

    const levelIsLocked = currentElement.hasClass('locked');

    // lock all nodes
    $.each(nodesLevelSortedObject[visibilityLevel], (nodeId) => {
        const sortedNode = nodesLevelSortedObject[visibilityLevel][nodeId];
        if((typeof sortedNode !== 'undefined') && (typeof sortedNode.domNode !== 'undefined')) {
            sortedNode.domNode.toggleClass('locked', levelIsLocked);
        }
    });

    // lock all edges
    $.each(edgesLevelSortedObject[visibilityLevel], (edgeId) => {
        const sortedEdge = edgesLevelSortedObject[visibilityLevel][edgeId];
        if((typeof sortedEdge !== 'undefined') && (typeof sortedEdge.domNode !== 'undefined')) {
            sortedEdge.domNode.toggleClass('locked', levelIsLocked);
        }
    });
}

function updateMapVisibilityLevelScales() {
    // const artificalInitScale =  0.065; // not used at the moment
    const visibilityMapHeight = store.get().map.measurement.height;
    const viewportHeight = window.innerHeight;
    const minVisibilityLevels = 1;
    const maxVisibilityLevels = store.get().map.visibilityLevels;
    const maxVisibilityLevelScale = 3;
    const maxVisibilityLevelSteps = 3;
    const ratioHeight = viewportHeight / visibilityMapHeight;
    let startVisibilityLevelScale = 1;

    // check if start scale factor should be less than 1
    if(ratioHeight < 1) {
        startVisibilityLevelScale = ratioHeight;
    }

    // calculate scale factor
    const visibilityLevelScaleFactor = Math.exp(Math.log(
        (maxVisibilityLevelScale - startVisibilityLevelScale) / (maxVisibilityLevels * maxVisibilityLevelSteps - minVisibilityLevels)
    ));

    // add all possible scale levels to one object
    currentVisibilityLevelScales = {};
    currentVisibilityLevelScales[1] = startVisibilityLevelScale;
    for(let i=1; i < store.get().map.visibilityLevels; i++) {
        currentVisibilityLevelScales[i + 1] = startVisibilityLevelScale + visibilityLevelScaleFactor * i;
    }
}

function updateMapVisibilityLevelKeypress(direction) {
    let clickVisibilityLevel = 0;

    if(direction === '+') {
        clickVisibilityLevel = store.get().map.visibilityLevels - parseInt(currentVisibilityLevel);
    } else if(direction === '-') {
        clickVisibilityLevel = store.get().map.visibilityLevels - parseInt(currentVisibilityLevel) + 2;
    }

    // check if visibility level change is possible
    if(clickVisibilityLevel > 0 && clickVisibilityLevel <= store.get().map.visibilityLevels){
        $(`map-controls > ul [data-visibility-level="${clickVisibilityLevel}"]`).trigger('click');
    }
}

// LEVEL CONTROL MAP
// ---------------------------------------------------------------
function toggleMapLevelControl(currentElement) {

    if(currentElement.hasClass('active') !== true) {
        currentElement.addClass('active');
        mapLevelControlWrapper.removeClass('hide');
        mapLevelControlIsActive = true;

    } else {
        currentElement.removeClass('active');
        mapLevelControlWrapper.addClass('hide');
        mapLevelControlIsActive = false;

    }
}

function updateMapLevelControl(type, id = '-1') { // id = -1 = init

    if(type === 'init') {
        updateMapLevelControlInitNode();
        updateMapLevelControlInitEdge();
    }

    if(type === 'node-added' || type === 'node-copied') {
        updateMapLevelControlAddedOrCopiedNode(id);
    }

    if(type === 'node-removed') {
        updateMapLevelControlRemoveNode(id);
    }

    if(type === 'node-visibility-level-updated') {
        updateMapLevelControlRemoveNode(id);
        updateMapLevelControlAddedOrCopiedNode(id);
    }

    if(type === 'edge-added') {
        updateMapLevelControlAddEdge(id);
    }

    if(type === 'edge-removed') {
        updateMapLevelControlRemoveEdge(id);
    }

    if(type === 'edge-visibility-level-updated') {
        updateMapLevelControlRemoveEdge(id);
        updateMapLevelControlAddEdge(id);
    }

    log('--- map.js ---');
    log('client nodes level sorted object');
    log(nodesLevelSortedObject);
    log('client edges level sorted object');
    log(edgesLevelSortedObject);
    log('---------------');
}

// LEVEL CONTROL NODES
// ---------------------------------------------------------------
let nodesLevelSortedObject = {};

function updateMapLevelControlInitNode() {
    let visibilityLevel = 1; // start level > increased automatically
    nodesLevelSortedObject = {};

    // iterate over all visibility levels
    for(visibilityLevel; visibilityLevel <= store.get().map.visibilityLevels; visibilityLevel++) {
        const collectedNodesLevelObject = {};

        // add collected nodes to level object based on visibility level range (min/max)
        $.each(store.get().nodes, (key, node) => {
            if(node.visibility.minLevel <= visibilityLevel && node.visibility.maxLevel >= visibilityLevel) {
                collectedNodesLevelObject[key] = {
                    name: `${i18nJson.map.levelControl.node.buttonValue} ${key}`,
                    domNode: $(`node[data-id="${key}"]`), // select dom node and save into object > better for node/level toggle visible/invisible >performance improvements
                };
            }
        });

        nodesLevelSortedObject[visibilityLevel] = collectedNodesLevelObject;
    }

    // prepare level node markup
    let mapLevelControlTemplate = `<span class="map-level-control-headline">${i18nJson.map.levelControl.headlines.levelsAndNodes}</span>`;
    mapLevelControlTemplate += '<ul class="map-level-control-wrapper">';

    // prepare level and node markup
    $.each(nodesLevelSortedObject, (key, nodes) => {
        mapLevelControlTemplate += `<li class="map-level-control-levels" data-level-id="${key}">`;
            mapLevelControlTemplate += `<div class="map-level-control-level"><span class="map-level-control-level-button" data-clicked-level-id="${key}"><input type="checkbox" checked />${i18nJson.map.levelControl.level.buttonValue} ${key}</span>`;
            mapLevelControlTemplate += (Object.keys(nodesLevelSortedObject[key]).length > 0) ? '<span class="map-level-control-nodes-toggle">⌃</span>' : '<span class="map-level-control-nodes-toggle hide">⌃</span>'; // level has nodes > show toggle
            mapLevelControlTemplate += '</div>';

            mapLevelControlTemplate += '<ul class="map-level-control-nodes hide">';

            $.each(nodes, (key) => {
                mapLevelControlTemplate += `<li class="map-level-control-node" data-node-id="${key}"><input type="checkbox" checked />${i18nJson.map.levelControl.node.buttonValue} ${key}</li>`;
            });

            mapLevelControlTemplate += '</ul>';

        mapLevelControlTemplate += '</li>';
    });

    mapLevelControlTemplate += '</ul>';

    // add level and nodes markup to dom
    mapLevelControlNodesWrapper.html(mapLevelControlTemplate);
}

function updateMapLevelControlAddedOrCopiedNode(id) {
    let visibilityLevel = 1; // start level > increased automatically
    let nodeMarkup = '';

    // iterate over all visibility levels
    for(visibilityLevel; visibilityLevel <= store.get().map.visibilityLevels; visibilityLevel++) {

        if(store.get().nodes[id].visibility.minLevel <= visibilityLevel && store.get().nodes[id].visibility.maxLevel >= visibilityLevel) {
            const collectedNodesLevelObject = {
                name: `${i18nJson.map.levelControl.node.buttonValue} ${id}`,
                domNode: $(`node[data-id="${id}"]`), // select dom node and save into object > better for node/level toggle visible/invisible >performance improvements
            };

            // add markup
            nodeMarkup = `<li class="map-level-control-node" data-node-id="${id}"><input type="checkbox" checked />${i18nJson.map.levelControl.node.buttonValue} ${id}</li>`;

            const mapLevelControlNodes = mapLevelControlNodesWrapper.find(`.map-level-control-levels[data-level-id="${visibilityLevel}"] > .map-level-control-nodes`);
            mapLevelControlNodes.append(nodeMarkup);

            // sort map level control nodes
            mapLevelControlNodes.find('li.map-level-control-node').sort(sortNodesLi).appendTo(mapLevelControlNodes);

            // add to nodes level sorted object
            nodesLevelSortedObject[visibilityLevel][id] = collectedNodesLevelObject;

            // if dom node could not be selected > dom delay > repair nodes level sorted object
            updateMapLevelControlRepairSelectedDomNodes();
        }

        // level has nodes > show toggle
        if(Object.keys(nodesLevelSortedObject[visibilityLevel]).length > 0) {
            const mapLevelControlNodes = $(`.map-level-control-levels[data-level-id="${visibilityLevel}"]`);
            mapLevelControlNodes.find('.map-level-control-nodes-toggle').removeClass('hide');

            // show map level control nodes > based on map level control nodes toggle is shown again
            if(mapLevelControlNodes.find('.map-level-control-nodes-toggle').hasClass('active') === true) {
                mapLevelControlNodes.find('> .map-level-control-nodes').removeClass('hide');
            }
        } else {
            $(`.map-level-control-levels[data-level-id="${visibilityLevel}"] .map-level-control-nodes-toggle`).addClass('hide');
        }
    }
}

function updateMapLevelControlRemoveNode(id) {
    // remove node from nodes level sorted object
    $.each(nodesLevelSortedObject, (key) => {
        delete nodesLevelSortedObject[key][id];

        const mapLevelControlNodes = $(`.map-level-control-levels[data-level-id="${key}"]`);

        // level has nodes > show toggle
        if(Object.keys(nodesLevelSortedObject[key]).length > 0) {
            mapLevelControlNodes.find('.map-level-control-nodes-toggle').removeClass('hide');
        } else {
            mapLevelControlNodes.find('.map-level-control-nodes-toggle').addClass('hide');
            mapLevelControlNodes.find('> .map-level-control-nodes').addClass('hide'); // hide map level control nodes > based on map level control nodes toggle is hidden
        }
    });

    // remove node markup
    mapLevelControlNodesWrapper.find(`.map-level-control-nodes > .map-level-control-node[data-node-id="${id}"]`).remove();
}

let domNodeTimeout = undefined;

function updateMapLevelControlRepairSelectedDomNodes() {
    clearTimeout(domNodeTimeout);

    domNodeTimeout = setTimeout(() => {

        $.each(nodesLevelSortedObject, (levelId) => {

            $.each(nodesLevelSortedObject[levelId], (nodeId) => {
                const sortedObject = nodesLevelSortedObject[levelId][nodeId] || {};

                // take care of unselected dom nodes and repair it
                if(!sortedObject.domNode || sortedObject.domNode.length === 0) {
                    sortedObject.name = `${i18nJson.map.levelControl.node.buttonValue} ${nodeId}`;
                    sortedObject.domNode = $(`node[data-id="${nodeId}"]`); // select dom node and save into object > performance improvements
                    nodesLevelSortedObject[levelId][nodeId] = sortedObject;
                }
            });
        });
    }, 50);
}

function toggleMapLevelControlVisibilityNode(currentElement) {
    const nodeId = currentElement.data('node-id');
    const nodeIsChecked = currentElement.find('input').is(':checked');
    const nodeInput = mapLevelControlNodesWrapper.find(`.map-level-control-node[data-node-id="${nodeId}"] input`);

    // set input checked or unchecked overall levels
    // > one node could be at more than one level
    if(nodeIsChecked) {
        nodeInput.prop('checked', false);
    } else {
        nodeInput.prop('checked', true);
    }

    // hide node based on nodes level sorted object
    $.each(nodesLevelSortedObject, (levelId) => {
        const sortedNode = nodesLevelSortedObject[levelId][nodeId];

        if((typeof sortedNode !== 'undefined') && (typeof sortedNode.domNode !== 'undefined')) {

            if(nodeIsChecked === true) {
                sortedNode.domNode.addClass('hide');

            } else {
                sortedNode.domNode.removeClass('hide');

            }
        }
    });
}

function toggleMapLevelControlVisibilityLevel(currentElement) {
    const levelId = currentElement.data('clicked-level-id');
    const levelIsChecked = currentElement.find('input').is(':checked');
    const levelInput = currentElement.find('input');
    let nodeInput = {};

    // set level input checked or unchecked
    if(levelIsChecked) {
        levelInput.prop('checked', false);
    } else {
        levelInput.prop('checked', true);
    }

    // hide all nodes based on levelId
    $.each(nodesLevelSortedObject[levelId], (nodeId) => {
        const sortedNode = nodesLevelSortedObject[levelId][nodeId];

        if((typeof sortedNode !== 'undefined') && (sortedNode.domNode !== 'undefined')) {

            // find node input checkboxes
            nodeInput = mapLevelControlNodesWrapper.find(`.map-level-control-node[data-node-id="${nodeId}"] input`);

            // level is checked > hide nodes and check or uncheck input
            if(levelIsChecked === true) {
                nodesLevelSortedObject[levelId][nodeId].domNode.addClass('hide');
                nodeInput.prop('checked', false);

            } else {
                nodesLevelSortedObject[levelId][nodeId].domNode.removeClass('hide');
                nodeInput.prop('checked', true);

            }
        }
    });
}

// LEVEL CONTROL EDGES
// ---------------------------------------------------------------
let edgesLevelSortedObject = {};

function updateMapLevelControlInitEdge() {
    $.each(store.get().edges, (key) => {
        edgesLevelSortedObject[key] = $(`edge[data-id="${key}"]`);
    });

    // prepare level edge markup
    let mapLevelControlTemplate = `<span class="map-level-control-headline">${i18nJson.map.levelControl.headlines.edges}</span>`;
    mapLevelControlTemplate += '<ul class="map-level-control-wrapper">';
    mapLevelControlTemplate += `<li class="map-level-control-all-edges"><input type="checkbox" checked />${i18nJson.map.levelControl.edge.buttonValue}</li>`;
    mapLevelControlTemplate += '</ul>';

    // add level nodes markup to dom
    mapLevelControlEdgesWrapper.html(mapLevelControlTemplate);
}

function updateMapLevelControlAddEdge(id) {
    edgesLevelSortedObject[id] = $(`edge[data-id="${id}"]`);

    // if dom edge could not be selected > dom delay > repair edges level sorted object
    updateMapLevelControlRepairSelectedDomEdges();
}

function updateMapLevelControlRemoveEdge(id) {
    delete edgesLevelSortedObject[id];
}

let domEdgeTimeout = undefined;

function updateMapLevelControlRepairSelectedDomEdges() {
    clearTimeout(domEdgeTimeout);

    domEdgeTimeout = setTimeout(() => {
        $.each(edgesLevelSortedObject, (id) => {
            edgesLevelSortedObject[id] = $(`edge[data-id="${id}"]`);
        });
    }, 50);
}

function toggleMapLevelControlVisibilityAllEdges(currentElement) {
    const checkbox = currentElement.find('input');
    const allEdgesIsChecked = currentElement.find('input').is(':checked');

    // set checkbox checked or not
    if(allEdgesIsChecked) {
        checkbox.prop('checked', false);
    } else {
        checkbox.prop('checked', true);
    }

    // hide all edges based on edges level sorted object
    $.each(edgesLevelSortedObject, (id) => {
        edgesLevelSortedObject[id].toggleClass('hide');
    });
}

// LEVEL CONTROL UTIL
// ---------------------------------------------------------------
function toggleMapLevelControlNodes(currentElement) {
    currentElement.toggleClass('active');
    currentElement.parents('li').find('.map-level-control-nodes').toggleClass('hide');
}

// ---------------------------------------------------------------
// NODE
// ---------------------------------------------------------------
function addNode(x, y, currentMapScale) {
    node.add(x, y, currentMapScale);
}

// ---------------------------------------------------------------
// UTIL
// ---------------------------------------------------------------
function removeSelectedNodeOrEdge() {
    const getSelectedElement = $('.selected');

    if(getSelectedElement.length > 0) {
        const getElementTagName = getSelectedElement.prop('tagName');
        const getElementId = getSelectedElement.data('id');

        // remove node
        if(getElementTagName === 'NODE' || getElementTagName === 'node') {
            node.remove(getSelectedElement, getElementId);

        // remove edge
        } else {
            edge.remove(getSelectedElement, getElementId);
        }
    }
}

function copySelectedNode() {
    const getSelectedElement = $('.selected');
    const getElementId = getSelectedElement.data('id');
    node.copy(getElementId)
}

function sortNodesLi(a, b) {
    return (parseInt($(b).data('node-id'))) < (parseInt($(a).data('node-id'))) ? 1 : -1;
}

// MANAGE MAP USERS
let mapUsers = [];// TODO remove mapUsers, use users instead
let isExpandButtonShown = false;
const USERS = {
    LIMIT: 4,
};
// relevant to a classnames
const COLORS = [
    'orange',
    'blue-grey',
    'golden',
    'dusky-rose',
    'sea',
    'pink',
    'greeny-blue',
    'pale-teal'
]
let colorUserLastIndex = null;
let expandButtonVisibilityStatus = false;
// ---------------------------------------------------------------
function mapUserAdd(user){
    const mapUserList = $('map-user-list');
    const isHidden = mapUsers.length >= USERS.LIMIT ? 'hide' : '';
    userAssignColor(user.id);
    const userColor = userGetColor(user.id);
    mapUserList.append(`<map-user data-id=${user.id} class="${userColor} ${isHidden}">${user.initials}</map-user>`);
    // push user to local map users storage
    mapUsers.push(user);
    users.push(user);
    userPointerAdd(user);
    
    expandButtonCheckVisibility();
    log('');
    log('------------------');
    log('user color: ')
    log(userColor);
    log('usersColorsAssigned: ')
    log(usersColorsAssigned);
    log('users are: ');
    log(users);
    log(mapUsers);
    log('user added');
    log('------------------');
}

function formUserAdd(user){
    const mapUserList = $('map-user-list');
    const isHidden = users.length >= USERS.LIMIT ? 'hide' : ''; // since current user won't be shown it must be meant that's why + 1 to limit
    userAssignColor(user.id);
    const userColor = userGetColor(user.id);
    mapUserList.append(`<map-user data-id=${user.id} class="${userColor} ${isHidden}">${user.initials}</map-user>`);
    // push user to local map users storage
    mapUsers.push(user);
    users.push(user);
    
    expandButtonCheckVisibility();
    log('FORM user added:')
    log(user);
    log('______________');
}

function userPointerAdd(user){
    const userColor = userGetColor(user.id);
    const userPointer = `<map-user-pointer data-pointer-id="${user.id}" class="${userColor}">
      <i class="fas fa-location-arrow"></i><span>${user.name.split(' ')[0]}</span>
    </map-user-pointer>`;
    const map = $('map');
    map.append(userPointer);
}

function userPointerReceived(UserState) {
    const currentPointer = $(`map-user-pointer[data-pointer-id=${UserState.user.id}]`);
    if(!currentPointer) return;
    currentPointer.css({
        top: UserState.editor.y,
        left: UserState.editor.x
    });
}

let pointerTimer = undefined;
const pointerFrequencyAtSecond = 8; // how often to send a pointer position data
function userPointerSend(event) {
    const currentEdit = $('.selected');
    const currentMapScale = currentVisibilityLevelScales[currentVisibilityLevel];
    // stop sending data if some element edited at the moment/ no timer / timeout is working / map is dragging
    // also check if user defined
    if (
      (!pointerTimer || !currentEdit.length &&
      (new Date() - pointerTimer)/(1000/pointerFrequencyAtSecond) > 1 ) && !isDragging && userCurrent) {
        const mapHeight = store.get().map.measurement.height;
        const newMapOffsetY = (mapHeight*currentMapScale - mapHeight)/2 - store.get().map.position.y;
        const mapWidth = store.get().map.measurement.width;
        const newMapOffsetX = (mapWidth*currentMapScale - mapWidth)/2 - store.get().map.position.x;
        let UserState = {
            editor: {
                x: (event.clientX + newMapOffsetX) / currentMapScale,
                y: (event.clientY + newMapOffsetY) / currentMapScale
            },
            user: userCurrent,
        };
        socket.emit('update user state', UserState);
        pointerTimer = new Date();
    }
}

function userPointerRemove(user){
    const userPointer = $(`map-user-pointer[data-pointer-id=${user.id}]`);
    userPointer.remove();
}

function isFormUser(userId){
    const isForm = formUsers.findIndex(formUserId => parseInt(formUserId) === parseInt(userId));
    return isForm > -1;
}

function mapUserRemove(userToRemove){
    const mapUser = $(`map-user[data-id=${userToRemove.id}]`);
    const userIndex = users.findIndex( user => parseInt(user.id) === parseInt(userToRemove.id));
    userUnassignColor(userToRemove.id);
    if(!isFormUser(userToRemove.id)) {
        userPointerRemove(userToRemove);
    } else {
        log(formUsers.indexOf(userToRemove.id));
        formUsers.splice(formUsers.indexOf(userToRemove.id))
    }
    mapUser.remove();
    mapUsers.forEach((user, index, arr) => {
        if (parseInt(user.id) === parseInt(userToRemove.id)){
            arr.splice(index, 1);
        }
    });
    users.splice(userIndex, 1);
    colorUserLastIndex--;
    
    expandButtonCheckVisibility();
}

function mapUsersHide(users){
    const usersHidden = $('map-user');
    users.forEach((user,index) => {
        if( index > USERS.LIMIT - 1 ){
            $(usersHidden[index]).addClass('hide');
        }
    })
    
    expandButtonShow();
}
function mapUsersShow(users){
    const usersHidden = $('map-user.hide');
    usersHidden.removeClass('hide');
    expandButtonHide();
    
    setTimeout(()=>{
        mapUsersHide(users);
    }, 3000);
    
}

function expandButtonCheckVisibility(){
    if (mapUsers.length > USERS.LIMIT && !expandButtonVisibilityStatus) {
        expandButtonShow();
    } else if (mapUsers.length <= USERS.LIMIT && expandButtonVisibilityStatus) {
        expandButtonHide();
    }
}

function expandButtonShow(){
    const expandButton = $('map-user-expand');
    expandButton.removeClass('hide');
    expandButtonVisibilityStatus = true;
}

function expandButtonHide(){
    const expandButton = $('map-user-expand');
    expandButton.addClass('hide');
    expandButtonVisibilityStatus = false;
}

// MAP EDITS

// called once at 'update active edits' event by socket
function mapInitialEditsShow() {
    let elementType;
    for ( let element in activeEdits ) if (activeEdits.hasOwnProperty(element)) {
        const currentEdits = activeEdits[element];
        if (Object.keys(currentEdits).length > 0) {
            // map, edges, nodes -> map, edge, node
            elementType = element[element.length - 1] === "s" ? element.slice(0, -1) : element;
            for (let edit in currentEdits) if (currentEdits.hasOwnProperty(edit)) {
                log('+_');
                log(currentEdits[edit]);
                const elementEditors = currentEdits[edit];
                if (element !== 'map' && elementEditors.length) {
                    log(elementEditors);
                    elementEditors.forEach( editedElement => {
                        if (userCurrent.id !== editedElement.userId) {
                            const LockEvent = {
                                userId: editedElement.userId,
                                elemType: elementType,
                                elemId: edit,
                                lockExtent: editedElement.lockExtent
                            }
                            elementBlockDOM(elementType, edit);
                            elementEditTypeMarkOn(LockEvent);
                        }
                    })
                } else if (element === TYPES.MAP) {
                    // can have only one editor at moment
                    // map settings edited
                    // sectionBlockDOM(currentEdits[0].userId, '*'); // map can have '*' lock
                    log('element is a map at initial__;')
                    const LockEvent = {
                        userId: elementEditors[0].userId,
                        elemType: elementType,
                        elemId: null,
                        lockExtent: elementEditors[0].lockExtent
                    }
                    mapEditedCheckExternal(LockEvent);
                }
                /*if(element !== 'map' && currentEdits[edit][0] && (userCurrent.id !== currentEdits[edit][0].userId)){
                    elementBlockDOM(elementType, edit);
                    const LockEvent = {
                        userId: currentEdits[edit][0].userId,
                        elemType: elementType,
                        elemId: edit,
                        lockExtent: currentEdits[edit][0].lockExtent
                    }
                    elementEditTypeMarkOn(LockEvent);
                } else if (element === 'map' && userCurrent.id !== currentEdits[0].userId) {
                    // map settings edited
                    sectionBlockDOM(currentEdits[0].userId, 'appearance'); // map can have only appearance lock
                    mapEditedCheckExternal();
                }*/
            }
        }
    }
}

function elementBlockDOM(el, dataId) {
    const element = $(el+`[data-id=${dataId}]`);
    const isStickToRight = element.width() < 65 ? 'edited--right-side' : '';
    element.addClass(`edited ${isStickToRight}`);
}

function elementUnblockDOM(el, dataId) {
    const element = $(el+`[data-id=${dataId}]`);
    const isStickToRight = element.width() < 65 ? 'edited--right-side' : '';
    element.removeClass(`edited ${isStickToRight}`);
}

function sectionEditedCheck(type){
    if (sectionCurrent) {
        $(document).trigger('sectionEditedOff', [sectionCurrent]);
    }
}

function sectionEditedSync(){
    const diff = {};
    diff.node = store.get().nodes;
    socket.emit('submit map edit', diff)
}

function edgeEditedCheck(){
    if (edgeCurrent) {
        log('from edgeEditedCheck');
        log(edgeCurrent);
        socket.emit('stop editing element', edgeCurrent);
        edgeDataSubmitSync(edgeCurrent.elemId);
        edgeCurrent = null;
    }
}

function edgeCreatedSend({fromNodeId, toNodeId}) {
    const diff = {};
    diff.edgeCreated = {
        [userCurrent.id] : {fromNodeId, toNodeId}
    }
    socket.emit('submit map edit', diff)
}

function edgeDataSubmitSync(edgeId){
    const diff = {edge: null};
    diff.edge = {[edgeId] : store.get().edges[edgeId]};
    socket.emit('submit map edit', diff);
}

function mapEditedCheck(){
    if (mapCurrent) {
        socket.emit('stop editing element', mapCurrent);
        mapCurrent = null;
        mapEditedSync();
    }
}

function mapEditedSync() {
    const diff = {};
    diff.map = store.get().map;
    socket.emit('submit map edit', diff)
}

function nodeCopiedSync(nodeId) {
    const diff = {};
    diff.copy = {[userCurrent.id] : nodeId};
    socket.emit('submit map edit', diff)
}

function nodeCreatedSync(mouseX, mouseY, currentMapScale){
    const diff = {};
    diff.create = {[userCurrent.id] : {mouseX, mouseY, currentMapScale}};
    socket.emit('submit map edit', diff)
}

function elementDeletedSync(elemType, elementId) {
    const diff = {};
    diff.delete = {[userCurrent.id] : {elemType: elemType, elemId: elementId}};
    socket.emit('submit map edit', diff)
}

function elementDeleteEmitted(diff){
    const userId = Object.keys(diff.delete)[0];
    let deleting = diff.delete[userId];
    if (deleting.elemType === TYPES.NODE){
        const elementDeletedDOM = $(`node[data-id=${deleting.elemId}]`);
        sectionCurrent = null;
        node.remove(elementDeletedDOM, deleting.elemId);
    } else if (deleting.elemType === TYPES.EDGE){
        const elementDeletedDOM = $(`edge[data-id=${deleting.elemId}]`);
        // remove edgeCurrent cause an error since after edge deleted event sending edgeSync event
        edgeCurrent = null;
        edge.remove(elementDeletedDOM, deleting.elemId);
    }
}

function mapEditedCheckExternal(LockEvent) {
    if (LockEvent.userId !== userCurrent.id) {
        const userColor = userGetColor(LockEvent.userId);
        $('map-settings').addClass(`edited ${userColor}`);
    }
}

function nodeDataSubmitSync(nodeId){
    /*// TODO force saving node to store
    $(document).trigger('nodeDataForceSaving');
    log('SEND after node has been saved');
    log(store.get().nodes[nodeId]);*/
    const diff = {node: null};
    diff.node = {[nodeId] : store.get().nodes[nodeId]};
    socket.emit('submit map edit', diff);
}

function elementEditTypeMarkOn(LockEvent) {
    const user = users.find( user => parseInt(user.id) === parseInt(LockEvent.userId));
    const userColor = userGetColor(LockEvent.userId);
    if (LockEvent.elemType !== "map"){
        // check user is form user
        // to show icon accordingly
        if(!isFormUser(LockEvent.userId)){
            $(`${LockEvent.elemType}[data-id=${LockEvent.elemId}]`).find(`i[data-edit=${LockEvent.lockExtent}]`).addClass(`${userColor}`)
        } else {
            $(`${LockEvent.elemType}[data-id=${LockEvent.elemId}]`).find(`i[data-edit='popup-form']`).addClass(`${userColor}`)
        }
    }
}

function elementEditTypeMarkOff(LockEvent) {
    const user = users.find( user => parseInt(user.id) === parseInt(LockEvent.userId));
    const userColor = userGetColor(LockEvent.userId);
    if (LockEvent.elemType !== "map"){
        if(!isFormUser(LockEvent.userId)){
            $(`${LockEvent.elemType}[data-id=${LockEvent.elemId}]`).find(`i[data-edit=${LockEvent.lockExtent}]`).removeClass(`${userColor}`)
        } else {
            $(`${LockEvent.elemType}[data-id=${LockEvent.elemId}]`).find(`i[data-edit='popup-form']`).removeClass(`${userColor}`)
        }
    }
}

function sectionBlockDOM(userId, lock){
    const lockExtent = lock === 'content' ? 'content' : 'appearance';
    const editedSection = $(`settings .headline[data-section=${lockExtent}]`);
    const user = users.find( user => parseInt(user.id) === parseInt(userId));
    const userColor = userGetColor(userId);
    const userInstance = `<map-user class="${userColor}">${user.initials}</map-user>`;
    const message = `<div class="editor-message">+++ ${user.name} is editing +++</div>`;
    editedSection.next().addBack().addClass('edited');
    editedSection.next().prepend(message);
    // add user instance to section
    editedSection.append(userInstance);
}

function sectionUnblockDOM(userId, lock){
    const editedSection = $(`settings .headline[data-section=${lock}]`);
    editedSection.removeClass('edited');
    editedSection.next().removeClass('edited');
    log('section UNBLOCKED HERE');
    log(editedSection.next().children('.editor-message'));
    editedSection.next().children('.editor-message').remove();
    // remove user instance from section
    editedSection.find('map-user').each((index, el)=>{
        $(el).remove();
    })
}

function userGetColor(userId){
    const userAssigned = usersColorsAssigned.find(userColor => userColor[Object.keys(userColor)[0]] === userId);
    const userAssignedIndex = Object.keys(userAssigned)[0];
    if (userAssignedIndex > -1) {
        const userColorIndex = usersColorsAssigned[userAssignedIndex]; // {colorIndex: userId}
        if (userColorIndex > COLORS.length) {
            const multiple = (userColorIndex / COLORS.length) >> 0;
            const colorIndex = userColorIndex % (COLORS.length * multiple);
            return COLORS[colorIndex];
        } else {
            return COLORS[userAssignedIndex];
        }
    }
}

function userAssignColor(userId){
    // check first availabe color and apply it
    // if no assigned colors use first one
    if (usersColorsAssigned.length){
        // since we going to find a 'hole' between indexArray and indexColor
        // so that we'll know which color isn't take
        usersColorsAssigned.sort((a,b) => {
            return parseInt(Object.keys(a)[0]) - parseInt(Object.keys(b)[0])
        });
        let userIndex = null;
        for ( let index = 0; index < usersColorsAssigned.length; index++){
            // check if available color equal to colorIndex
            // while it's not equal color is busy
            // userColor = {colorIndex: userId}
            const userColor = usersColorsAssigned[index];
            const userColorIndex = Object.keys(userColor)[0];
            if (index !== parseInt(userColorIndex)) {
                userIndex = index;
                usersColorsAssigned.push({[index]: userId})
                break;
            }
        }
        if(userIndex === null) {
            // if no 'hole' founded use user's index then
            usersColorsAssigned.push({[usersColorsAssigned.length]: userId})
        }
    } else {
        // first one association
        usersColorsAssigned.push({0 : userId})
    }
}

function userUnassignColor(userId){
    usersColorsAssigned.forEach((userColor, index, array) => {
        // userColor = {colorIndex: userId}
        const userColorIndex = Object.keys(userColor)[0]; // index to indentify the color
        
        if (userColor[userColorIndex] === userId) {
            array.splice(index, 1);
        }
    });
}



